import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  subsubcategories: [],
  products: [],
  loading: false,
  error: null,
  message: null,
};

export const subsubcategoryReducer = createReducer(initialState, (builder) => {
  builder
    .addCase("subsubcategoriesRequest", (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase("subsubcategoriesSuccess", (state, action) => {
      state.loading = false;
      state.subsubcategories = action.payload;
    })
    .addCase("subsubcategoriesFail", (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
    .addCase("createSubSubcategoryRequest", (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase("createSubSubcategorySuccess", (state, action) => {
      state.loading = false;
      state.subsubcategories = [...state.subsubcategories, action.payload];
      state.message = "Sub-subcategory created successfully!";
    })
    .addCase("createSubSubcategoryFail", (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
    .addCase("updateSubSubcategoryRequest", (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase("updateSubSubcategorySuccess", (state, action) => {
      state.loading = false;
      state.subsubcategories = state.subsubcategories.map((subsubcategory) =>
        subsubcategory._id === action.payload._id ? action.payload : subsubcategory
      );
      state.message = "Sub-subcategory updated successfully!";
    })
    .addCase("updateSubSubcategoryFail", (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
    .addCase("deleteSubSubcategoryRequest", (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase("deleteSubSubcategorySuccess", (state, action) => {
      state.loading = false;
      state.subsubcategories = state.subsubcategories.filter(
        (subsubcategory) => subsubcategory._id !== action.payload
      );
      state.message = "Sub-subcategory deleted successfully!";
    })
    .addCase("deleteSubSubcategoryFail", (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
    .addCase("subSubcategoryProductsRequest", (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase("subSubcategoryProductsSuccess", (state, action) => {
      state.loading = false;
      state.products = action.payload;
    })
    .addCase("subSubcategoryProductsFail", (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
    .addCase("clearMessages", (state) => {
      state.message = null;
    })
    .addCase("clearErrors", (state) => {
      state.error = null;
    });
});
